import _ from 'lodash';
import ReportHelpers from './report_helpers';
import Report, { ReportType } from './report';

export default class AgentReport extends Report {
  _getDataByAgentId() {
    return ReportHelpers.getDataById.call(this, 'responsesByAgentIDAndDay');
  }

  init() {
    return ReportHelpers.init(this._getDataByAgentId.bind(this));
  }

  getPerformanceReport() {
    this.dataByAgent = _.reduce(
      this.data,
      (acc, metricValues, metricName) => {
        _.forEach(metricValues, value => {
          const agentID = value['id'];

          if (!acc[agentID]) {
            acc[agentID] = {};
          }

          if (!acc[agentID][metricName]) {
            acc[agentID][metricName] = { count: 0, duration: 0 };
          }

          acc[agentID][metricName]['count'] += value['count'];
          if (value['duration']) {
            acc[agentID][metricName]['duration'] += value['duration'];
          }
        });
        return acc;
      },
      {}
    );

    return {
      getMetricByAgentID: (agentId, metric) => {
        return _.get(this.dataByAgent, `${agentId}.${metric}`, null);
      },
      getReportForAgent: agentId => {
        return _.get(this.dataByAgent, agentId, null);
      },
      getAllAgentIds: () => {
        return _.keys(this.dataByAgent);
      },
    };
  }

  get reportType() {
    return ReportType.AGENTS;
  }
}
